/**
 * @station/api-client — OpenAPI dokümanından ÜRETİLEN tipli istemci (AGENTS.md §3.10).
 *
 *   pnpm api:generate   → apps/api OpenAPI dokümanını dışa aktarır ve `src/generated/schema.ts` dosyasını üretir
 *
 * `src/generated/` elle düzenlenmez. Web ve mobil istemciler yalnızca bu paketi kullanır.
 */
import { problemDetailsSchema } from "@station/contracts";
import createClient from "openapi-fetch";
/** API'nin problem+json hatası; istemci `code` alanına göre davranır. */
export class ApiError extends Error {
    problem;
    response;
    constructor(problem, response) {
        super(problem.detail ?? problem.title);
        this.problem = problem;
        this.response = response;
        this.name = "ApiError";
    }
    get code() {
        return this.problem.code;
    }
    /** Alan bazında hata iletileri: { "title": "Başlık zorunludur" } — form kütüphanelerine doğrudan verilebilir. */
    get fieldErrors() {
        return Object.fromEntries((this.problem.errors ?? []).map((error) => [error.path, error.message]));
    }
}
/** problem+json olmayan (ağ geçidi, vekil) hata yanıtlarını da tek tipe indirger. */
export async function toApiError(response) {
    let body;
    try {
        body = await response.clone().json();
    }
    catch {
        body = undefined;
    }
    const parsed = problemDetailsSchema.safeParse(body);
    const problem = parsed.success
        ? parsed.data
        : {
            type: "about:blank",
            title: "Sunucuya ulaşılamadı ya da beklenmeyen bir yanıt alındı",
            status: response.status,
            code: response.status === 401
                ? "UNAUTHENTICATED"
                : response.status >= 500
                    ? "SERVICE_UNAVAILABLE"
                    : "INTERNAL_ERROR",
        };
    return new ApiError(problem, response);
}
export function createApiClient(options) {
    const client = createClient({
        baseUrl: options.baseUrl.replace(/\/+$/, ""),
        ...(options.fetch ? { fetch: options.fetch } : {}),
        ...(options.credentials ? { credentials: options.credentials } : {}),
    });
    // Ara katman nesneleri YERİNDE değiştirir ve hiçbir şey döndürmez: openapi-fetch döndürülen değeri "yeni istek / yanıt"
    // sayıp `instanceof Request/Response` ile denetler; React Native'de (Expo) `fetch` yanıtı global `Response`'un örneği
    // olmadığından bu denetim düşer ("onResponse: must return new Response()").
    const middleware = {
        async onRequest({ request }) {
            const token = await options.getAccessToken?.();
            if (token)
                request.headers.set("Authorization", `Bearer ${token}`);
            if (options.clientKind)
                request.headers.set("X-Client-Kind", options.clientKind);
        },
        async onResponse({ response }) {
            if (!response.ok)
                throw await toApiError(response);
        },
    };
    client.use(middleware);
    return client;
}
/** Oluşturma isteklerinde kullanılacak yeni bir Idempotency-Key üretir. */
export function newIdempotencyKey() {
    return globalThis.crypto.randomUUID();
}
//# sourceMappingURL=index.js.map